import { useParams } from "react-router-dom";
import { useGetHouseholdQuery, useUpdateHouseholdMutation } from "@/features/households/api";
import { HouseholdForm } from "@/features/households/components/HouseholdForm";
import { Card, Box, Typography } from "@mui/joy";

export function SettingsHouseholdPage() {  
    const { householdId } = useParams();
    const { isFetching, data } = useGetHouseholdQuery({ householdId });
    const [saveHousehold, saveResult] = useUpdateHouseholdMutation();
  
    function save(data) {
      saveHousehold({ data, id: householdId });
    }
      
    return (isFetching ? 'Loading...' : <SettingsHouseholdForm data={data.data} save={save} saveResult={saveResult} />);    
  }
  
  function SettingsHouseholdForm({ data, save, saveResult }) {  
    return (    
      <Card variant="outlined" sx={{ p: 2.5 }}>      
        <Box sx={{ mb: 2 }}>
          <Typography level="h4">Household Preferences</Typography>
          <Typography level="body-sm">Customize your household settings</Typography>
        </Box>
        <HouseholdForm data={data} save={save} saveResult={saveResult} saveButton={{ label: "Save Changes", size: "md", fullWidth: false, mt: 4 }} />
      </Card>
    );
  }
  
  